<template>
  <v-flex>
    <v-flex class="subheading">{{ $t('Availability') }}:</v-flex>
    <v-layout
      class="text--disabled py-2 subheading">
      <v-flex>
        <span class="d-block py-1">{{ $t('Min per order') }}: {{ product.inventory.min_per_order || '1' }}</span>
        <span class="d-block">{{ $t('Max per order') }}: {{ product.inventory.max_per_order || $t('unlimited') }}</span>
        <span
          v-if="product.classification !== 'bundle'"
          class="d-block py-1">{{ $t('In Stock') }}: {{ product.inventory.quantity }}</span>
        <span class="d-block">{{ $t('Policy') }}: {{ $t(product.inventory.policy) }}</span>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'OrderDraftItemAvailability',

  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
